var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationSent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationSent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.88553846,11.608 C5.80184615,11.5264 5.76,11.404 5.76,11.3224 C5.76,11.2408 5.80184615,11.1184 5.88553846,11.0368 L6.47138462,10.4656 C6.63876923,10.3024 6.88984615,10.3024 7.05723077,10.4656 L7.09907692,10.5064 L9.40061538,12.9136 C9.48430769,12.9952 9.60984615,12.9952 9.69353846,12.9136 L15.3009231,7.2424 L15.3427692,7.2424 L15.3427692,7.2424 C15.5101538,7.0792 15.7612308,7.0792 15.9286154,7.2424 L16.5144615,7.8136 C16.6818462,7.9768 16.6818462,8.2216 16.5144615,8.3848 L16.5144615,8.3848 L9.81907692,15.1576 C9.73538462,15.2392 9.65169231,15.28 9.52615385,15.28 C9.40061538,15.28 9.31692308,15.2392 9.23323077,15.1576 L5.96923077,11.7304 L5.88553846,11.608 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-502.000000, -682.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Validation-sent",
    transform: "translate(485.000000, 664.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotificationSent",
    transform: "translate(17.800000, 18.800000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,-1.70530257e-13 C5.02449231,-1.70530257e-13 0,5.02406154 0,11.2 C0,17.3759385 5.02449231,22.4 11.2,22.4 C17.3755077,22.4 22.4,17.3759385 22.4,11.2 C22.4,5.02406154 17.3755077,-1.70530257e-13 11.2,-1.70530257e-13 Z",
    id: "Shape",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationSent);
export default __webpack_public_path__ + "static/media/icNotificationSent.5e3ac8a3755c08bda9e21a3af7a58f78.svg";
export { ForwardRef as ReactComponent };